import React, { type FC } from "react";

import { Editor } from "~/components/code/editor";

import type { FullComponent, FullRelation } from "../../common/openapi";
import { CloseDrawerButton, CopyToClipboardDrawerButton, ExplorationDrawer } from "../react/drawer/ExplorationDrawer";

import { ElementDrawerTitle } from "./element-drawer-title";

export interface ElementJsonDefinitionDrawerProps {
	when: undefined | FullComponent | FullRelation;
}

export const ElementJsonDefinitionDrawer: FC<ElementJsonDefinitionDrawerProps> = ({ when }) => {
	const jsonContent = React.useMemo(() => JSON.stringify(when, null, "\t"), [when]);

	return (
		<ExplorationDrawer
			data-testid="element-json-definition-drawer"
			footer={
				<>
					<CloseDrawerButton />
					<CopyToClipboardDrawerButton content={jsonContent} contentType="JSON definition" />
				</>
			}
			headerTitle={(fullElement) => <ElementDrawerTitle fullElement={fullElement} typeOfData="JSON definition" />}
			when={when}
		>
			<Editor height="100%" language="json" readOnly value={jsonContent} width="100%" />
		</ExplorationDrawer>
	);
};
